import { render, staticRenderFns } from "./wtPromptTemplates.component.vue?vue&type=template&id=1125deca&scoped=true&"
import script from "./wtPromptTemplates.component.vue?vue&type=script&lang=js&"
export * from "./wtPromptTemplates.component.vue?vue&type=script&lang=js&"
import style0 from "./wtPromptTemplates.component.vue?vue&type=style&index=0&id=1125deca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125deca",
  null
  
)

export default component.exports